module.exports = __webpack_public_path__ + "c76b774e8291537f1a89a9add04d541e.png";